import { render, staticRenderFns } from "./CoachGoals.vue?vue&type=template&id=50b783af&"
import script from "./CoachGoals.vue?vue&type=script&lang=js&"
export * from "./CoachGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports